import React from "react";
import SatisfactionSurvey from "./components/SatisfactionSurvey";
import "./styles.css";

function App() {
  return <SatisfactionSurvey />;
}

export default App;
